<!-- Bell Button -->
<div class="notif-bell-wrapper">
  <button
    mat-icon-button
    matTooltip="Notifications"
    aria-label="Show notifications"
    [bcNavLink]="'/notifications'"
    (click)="toggleDropdown(); $event.stopPropagation()">
    <mat-icon
      aria-hidden="false"
      matBadge="{{ unreadCount }}"
      matBadgeColor="warn"
      matBadgeSize="small"
      matBadgePosition="above after"
      [matBadgeHidden]="unreadCount === 0"
      class="notification-icon">
      notifications
    </mat-icon>
  </button>

  <!-- Dropdown Panel -->
  <div class="notif-dropdown"
       [class.open]="isDropdownOpen"
       (click)="$event.stopPropagation()">

    <!-- Header -->
    <div class="notif-dropdown-header">
      <h3>Notifications</h3>
      <div class="notif-dropdown-actions">
        <button mat-icon-button
                matTooltip="Mark all as read"
                aria-label="Mark all notifications as read"
                [disabled]="unreadCount === 0"
                (click)="onMarkAllRead()">
          <mat-icon>done_all</mat-icon>
        </button>
        <button mat-icon-button
                matTooltip="Notification settings"
                aria-label="Notification settings"
                (click)="onOpenSettings()">
          <mat-icon>settings</mat-icon>
        </button>
      </div>
    </div>

    <!-- Tabs -->
    <div class="notif-dropdown-tabs">
      <button class="notif-tab"
              [class.active]="activeTab === 'all'"
              (click)="switchTab('all')">
        All
        <span class="notif-tab-badge" *ngIf="unreadCount > 0">{{ unreadCount }}</span>
      </button>
      <button class="notif-tab"
              [class.active]="activeTab === 'unread'"
              (click)="switchTab('unread')">
        Unread
      </button>
    </div>

    <!-- Organization scope. Only worth showing when the user actually has notifications elsewhere;
         on a single-organization account it would be a control with one meaningful state. -->
    <div class="notif-org-scope" *ngIf="currentCompanyId && (otherOrgCount > 0 || orgScope === 'all')">
      <button class="notif-scope-btn"
              [class.active]="orgScope === 'current'"
              (click)="switchOrgScope('current')">
        {{ companyName(currentCompanyId) || 'This organization' }}
      </button>
      <button class="notif-scope-btn"
              [class.active]="orgScope === 'all'"
              (click)="switchOrgScope('all')">
        All organizations
        <span class="notif-scope-badge" *ngIf="otherOrgUnreadCount > 0">{{ otherOrgUnreadCount }}</span>
      </button>
    </div>

    <!-- Notification List -->
    <div class="notif-dropdown-list">
      <ng-container *ngIf="filteredNotifications.length > 0; else emptyState">
        <div *ngFor="let note of filteredNotifications; let i = index; trackBy: trackByNotifId"
             class="notif-item"
             [class.unread]="!note.isRead"
             (click)="onNotificationClick(note, i)">

          <!-- Avatar -->
          <div class="notif-avatar" [ngClass]="getAvatarConfig(note).cssClass">
            <span class="notif-avatar-initials">{{ note.senderInitials }}</span>
            <span class="notif-avatar-badge" [ngClass]="getAvatarConfig(note).iconClass">
              <mat-icon>{{ getAvatarConfig(note).icon }}</mat-icon>
            </span>
          </div>

          <!-- Content -->
          <div class="notif-content">
            <div class="notif-text" [innerHTML]="highlightMessage(note.message)"></div>

            <!-- Owning company for this notification. Surfaces so the admin knows which client
                 the change belongs to before clicking, and notes when clicking opens it in a new
                 tab under that organization. -->
            <div class="notif-client" *ngIf="companyName(note.companyId) as cname">
              <mat-icon>business</mat-icon>
              <span class="notif-client-name">{{ cname }}</span>
              <span class="notif-switch-hint" *ngIf="isCrossCompany(note)">
                <mat-icon>open_in_new</mat-icon>
                opens in a new tab
              </span>
            </div>

            <div class="notif-meta">
              <span class="notif-time">
                <mat-icon>schedule</mat-icon>
                {{ note.relativeTime }}
              </span>
              <span class="notif-unread-dot" *ngIf="!note.isRead"></span>
              <span class="notif-tag" *ngIf="getStatusTag(note) as tag" [ngClass]="tag.cssClass">
                {{ tag.label }}
              </span>
            </div>
          </div>

          <!-- Hover Actions -->
          <div class="notif-hover-actions">
            <button mat-icon-button
                    *ngIf="note.leaveRequestId != null"
                    matTooltip="View request"
                    aria-label="View leave request"
                    class="notif-action-btn"
                    (click)="onViewLeave(note); $event.stopPropagation()">
              <mat-icon>visibility</mat-icon>
            </button>
            <button mat-icon-button
                    matTooltip="Dismiss"
                    aria-label="Dismiss notification"
                    class="notif-action-btn delete"
                    (click)="onDismiss(note, i); $event.stopPropagation()">
              <mat-icon>close</mat-icon>
            </button>
          </div>
        </div>
      </ng-container>

      <!-- Empty State -->
      <ng-template #emptyState>
        <div class="notif-empty">
          <mat-icon>notifications_none</mat-icon>
          <span>{{ activeTab === 'unread' ? 'No unread notifications' : 'No notifications yet' }}</span>
        </div>
      </ng-template>
    </div>

    <!-- Footer -->
    <div class="notif-dropdown-footer">
      <a tabindex="0" role="button" (click)="onViewAll()" (keydown.enter)="onViewAll()">
        View all notifications
        <mat-icon aria-hidden="true">arrow_forward</mat-icon>
      </a>
    </div>
  </div>
</div>

<!-- Backdrop overlay -->
<div class="notif-overlay"
     *ngIf="isDropdownOpen"
     (click)="closeDropdown()">
</div>
